import { graphql } from 'react-relay';

export const gqlStartBillingPortalSession = graphql`
  mutation startBillingPortalSessionMutation {
    superposherStartMobileBillingPortalSession {
      url
    }
  }
`;
